export default function AppLayout({ children }) {
  return (
    <div className="nouvac-root">
      <div className="devis-hero__overlay" aria-hidden="true" />
      <div className="nouvac-bg" aria-hidden="true" />
      <div className="nouvac-shell">{children}</div>
    </div>
  );
}
